import Card from './Card'
import { Loading } from 'components/loading/Loading'

import s from './PackageList.module.scss'
import { usePowerPackageData } from 'hooks/usePowerPackageData'

export const PackageList = ({
  onSelectPackage,
  product,
}: {
  onSelectPackage: (uid: string) => void
  product?: string
}) => {
  const { powerPackageData } = usePowerPackageData()

  return (
    <>
      <div className={s.packageList}>
        {powerPackageData ? (
          powerPackageData?.allPower_packages.edges.map((edge, index) => {
            const uid = edge.node._meta.uid.split('_')[0]
            return (
              <Card
                key={`powerPackageCard-${index}`}
                item={edge.node}
                onCardSelection={onSelectPackage}
                isSelected={product === uid}
              />
            )
          })
        ) : (
          <Loading />
        )}
      </div>
    </>
  )
}
